import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations'
import actions from './action'
// import getters from './getters'
import { loadEditorContent } from './mutation-types'

Vue.use(Vuex)

const state = {
  userInfo: null,
  roomInfo: null,
  editorContent: loadEditorContent(),
  editor: null,
  user: null,
  actionData: null,
  codeContent: '',
  courseId: '',
  index: '',
  courseData: [],
  status: true
}

const getters = {
  isSava: state => {
    let status = false
    // if (data.data.length === 0) {
    //   status = true
    // }
    return status
  }
}

export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js